document.addEventListener('DOMContentLoaded', async function() {
  const config = JSON.parse(document.getElementById('collection-config').textContent);
  // Elements
  const productGrid = document.getElementById('product-grid');
  const noResults = document.getElementById('no-results');
  const errorEl = document.getElementById('collection-error');
  const loadingEl = document.getElementById('collection-loading');
  const productCount = document.querySelector('.collection-header__count');
  const retryProductsBtn = document.getElementById('retry-products-btn');
  const liquidPagination = document.querySelector('[data-liquid-pagination]');
  const collectionPage = document.querySelector('.collection-page');
  const inventoryUpdateBadge = document.querySelector('[data-inventory-update]');
  const filterSidebar = document.getElementById('collection-filter-sidebar');
  const filterToggleBtn = document.getElementById('collection-filter-toggle');
  const filterCloseBtn = document.getElementById('collection-filter-close');
  const collectionHandle = config.handle;
  const collectionCategoryBase = config.category;
  // Filter option order by game and filter key; values not listed sort A-Z after these.
  const FILTER_ORDERS = {
    pokemon: {
      rarity: ['Common', 'Uncommon', 'Rare', 'Rare Holo', 'Holo Rare', 'Holo Rare V', 'Holo Rare VMAX', 'Holo Rare VSTAR',
        'Rare Holo LV.X', 'Rare PRIME', 'LEGEND', 'Double Rare', 'Radiant Rare', 'Amazing Rare', 'ACE SPEC Rare', 'Ultra Rare',
        'Full Art Trainer', 'Character Rare', 'Character Super Rare', 'Shiny Rare', 'Shiny Ultra Rare', 'Illustration Rare',
        'Special Illustration Rare', 'Triple Rare', 'Hyper Rare', 'Mega Attack Rare', 'Mega Hyper Rare', 'Secret Rare',
        'Black White Rare', 'Pikachu Rare', 'RGB Rare', 'Futuristic Rare', 'Classic Collection', 'Promo'],
      'card type': ['Pokémon', 'Trainer', 'Energy']
    }
  };
  // Game/sports filter groups (set, rarity, card type, finish, ...) show as one-column lists with counts;
  // their names wrap badly in the two-column chips. Long lists start collapsed.
  const LIST_COLLAPSE_AFTER = 6;
  const isAllProductsCollection = config.isAll;
  const gameCatalog = window.TMMCollectionGames;
  const gameReleaseOrder = config.gameOrder;
  const gameDefinitions = config.gameDefinitions.filter(Boolean);
  const recentlySold = window.TMMRecentlySold;
  const currentCollectionCount = config.count;
  const storefrontCacheVersion = config.version;
  const collectionStateKey = `tmm_collection_state:${collectionHandle}`;
  const productCachePrefix = 'tmm_collection_products:';
  const productCacheSchemaVersion = `v6:${config.market}`;
  const productCacheMaxAgeMs = 2 * 60 * 1000;
  let productLoadFailed = false;
  let pendingScrollY = null;
  let pendingRenderedCount = 0;
  let productsReady = false;

  // Products at the event marked "Happening now" — fetched from the API to
  // bypass Liquid caching issues. Planned event inventory stays for sale.
  const tradeShowProxyUrl = config.inventoryUrl;
  let tradeShowProductIds = new Set();
  let tradeShowVariantIds = new Set();
  let tradeShowSelectionMode = 'products';
  let tradeShowEventHandles = [];
  let cacheVersion = null;
  const tradeShowPromise = tradeShowProxyUrl
    ? fetch(tradeShowProxyUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'get-trade-show-products' }),
        cache: 'no-store'
      })
      .then(r => r.json())
      .then(data => {
        tradeShowProductIds = new Set((data.product_ids || []).map(String));
        tradeShowVariantIds = new Set((data.variant_ids || []).map(String));
        tradeShowSelectionMode = data.selection_mode || 'products';
        tradeShowEventHandles = data.event_collection_handles || [];
        cacheVersion = data.cache_version || null;
      })
      .catch(err => { console.error('[TradeShow] Fetch failed:', err); })
    : Promise.resolve();

  // Hide live trade-show products everywhere except the live event collection.
  // Private events omit their handle from the public API, so the server-rendered flag also identifies it.
  function isLiveEventCollection() {
    return config.liveEventCollection === true || tradeShowEventHandles.includes(collectionHandle);
  }

  function shouldFilterTradeShow() {
    return tradeShowProductIds.size > 0 && !isLiveEventCollection();
  }

  function isVariantAtTradeShow(product, variant) {
    if (!tradeShowProductIds.has(String(product?.id))) return false;
    if (tradeShowSelectionMode === 'products') return true;
    return tradeShowVariantIds.has(String(variant?.id));
  }

  // All current category handles for fetching filterable products.
  const filterSources = config.filterCollections.filter(Boolean);
  const allFilterCollections = filterSources.map(source => source.handle);

  if (collectionCategoryBase && !allFilterCollections.includes(collectionCategoryBase)) {
    allFilterCollections.push(collectionCategoryBase);
  }

  const isFilterableCategoryCollection = Boolean(collectionCategoryBase) &&
    (collectionHandle === collectionCategoryBase ||
      collectionHandle.startsWith(`${collectionCategoryBase}-singles`) ||
      collectionHandle.startsWith(`${collectionCategoryBase}-graded`) ||
      collectionHandle.startsWith(`${collectionCategoryBase}-sealed`));

  function finishCollectionHydration() {
    collectionPage?.classList.remove('is-hydrating');
  }

  function currentStorefrontVersion() {
    return cacheVersion || storefrontCacheVersion || sessionStorage.getItem('pokemon_cache_version') || '';
  }

  function hasNewerVersion(latestVersion, currentVersion) {
    if (!latestVersion || !currentVersion) return false;
    const latestNumber = Number(latestVersion);
    const currentNumber = Number(currentVersion);
    if (!Number.isNaN(latestNumber) && !Number.isNaN(currentNumber)) {
      return latestNumber > currentNumber;
    }
    return latestVersion !== currentVersion;
  }

  function setInventoryUpdateAvailable(isAvailable) {
    inventoryUpdateBadge?.classList.toggle('is-visible', Boolean(isAvailable));
  }

  function startInventoryUpdateWatcher() {
    if (!tradeShowProxyUrl || !inventoryUpdateBadge) return;

    async function checkForUpdates() {
      if (document.hidden) return;
      try {
        const response = await fetch(tradeShowProxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'get-at-show-status' }),
          cache: 'no-store'
        });
        if (!response.ok) return;
        const data = await response.json();
        if (hasNewerVersion(data.cache_version, currentStorefrontVersion())) {
          setInventoryUpdateAvailable(true);
        }
      } catch (e) {}
    }

    window.setTimeout(checkForUpdates, 30000);
    window.setInterval(checkForUpdates, 90000);
  }

  // Store all products data
  let allProducts = [];
  let totalProducts = 0;

  const eventSeriesGroups = [
    {
      key: 'mega-evolutions',
      label: 'Mega Evolutions',
      expansions: ['Pitch Black', 'Chaos Rising', 'Perfect Order', 'Ascended Heroes', 'Phantasmal Flames', 'Mega Evolutions Base', 'Mega Evolution Black Star Promos']
    },
    {
      key: 'scarlet-violet',
      label: 'Scarlet & Violet',
      expansions: ['Black Bolt', 'White Flare', 'Destined Rivals', 'Journey Together', 'Prismatic Evolutions', 'Surging Sparks', 'Stellar Crown', 'Shrouded Fable', 'Twilight Masquerade', 'Temporal Forces', 'Paldean Fates', 'Paradox Rift', 'Scarlet & Violet 151', '151', 'Obsidian Flames', 'Paldea Evolved', 'Scarlet & Violet Base', 'Scarlet & Violet Promo']
    },
    {
      key: 'sword-shield',
      label: 'Sword & Shield',
      expansions: ['Crown Zenith', 'Silver Tempest', 'Lost Origin', 'Pokémon GO', 'Pokemon GO', 'Astral Radiance', 'Brilliant Stars', 'Fusion Strike', 'Evolving Skies', 'Chilling Reign', 'Battle Styles', 'Shining Fates', 'Vivid Voltage', "Champion's Path", 'Champions Path', 'Darkness Ablaze', 'Rebel Clash', 'Sword & Shield Base', 'Celebrations']
    },
    {
      key: 'sun-moon',
      label: 'Sun & Moon',
      expansions: ['Cosmic Eclipse', 'Unified Minds', 'Unbroken Bonds', 'Hidden Fates', 'Burning Shadows', 'Sun & Moon Base']
    },
    {
      key: 'xy',
      label: 'XY',
      expansions: ['Fates Collide', 'BREAKthrough', 'Phantom Forces', 'XY Base']
    },
    { key: 'black-white', label: 'Black & White', expansions: ['Dark Explorers'] },
    { key: 'e-card', label: 'e-Card', expansions: ['Skyridge'] },
    { key: 'wizards', label: 'Wizards of the Coast', expansions: ['Gym Heroes'] },
    {
      key: 'one-piece',
      label: 'One Piece Sets',
      expansions: ['The Time of Battle', "Adventure on Kami's Island", 'Adventure on Kamis Island', "The Azure Sea's Seven", 'The Azure Seas Seven', "The Azure Sea's Seven Extra", 'The Azure Seas Seven Extra', 'Carrying On His Will', 'Legacy of the Master', 'A Fist of Divine Speed', 'One Piece Heroines Edition', 'One Piece Card The Best Vol.2', 'Royal Blood', 'Wings of the Captain', 'Awakening of the New Era', 'ST-01: Straw Hat Crew', 'ST-23: Shanks', 'ST-29: Egghead', 'ST-30: EX Luffy & Ace']
    },
    {
      key: 'dragon-ball',
      label: 'Dragon Ball Sets',
      expansions: ['Brightness of Hope', 'Cross Force', 'Dual Evolution', 'Saiyans Pride', 'Wish for Shenron', 'Rivals Clash', 'New Adventure', 'Ultra Limit', 'Raging Roar', 'Blazing Aura', 'Awakened Pulse', 'Manga Booster 02', 'Manga Booster 01', 'Story Booster']
    },
    {
      key: 'lorcana',
      label: 'Lorcana Sets',
      expansions: ['Fabled', 'Reign of Jafar', 'Archazias Island', 'Azurite Sea', 'Shimmering Skies', 'Ursulas Return', 'Into the Inklands', 'Rise of the Floodborn', 'The First Chapter']
    },
    {
      key: 'magic',
      label: 'Magic Sets',
      expansions: ['Teenage Mutant Ninja Turtles', 'Final Fantasy', 'Tarkir Dragonstorm', 'Aetherdrift', 'Foundations', 'Duskmourn House of Horror', 'Bloomburrow', 'Modern Horizons 3', 'Outlaws of Thunder Junction', 'Murders at Karlov Manor']
    }
  ];

  const ignoredEventFilterTags = new Set([
    'promo', 'promos', 'stamped', 'single', 'singles', 'graded', 'sealed',
    'xxl', '3xl', '4xl', '5xl', 'xl', 'l', 'm', 's'
  ]);

  function eventFilterTagAllowed(tag) {
    const normalized = String(tag || '').trim().toLowerCase();
    if (!normalized || ignoredEventFilterTags.has(normalized)) return false;
    return !['language:', 'condition:', 'grader:', 'grade:', 'promo type:', 'card treatment:']
      .some(prefix => normalized.startsWith(prefix));
  }

  function eventExpansionMarkup(expansion) {
    const display = expansion === 'Scarlet & Violet 151' ? '151' : expansion.replace(/^set:\s*/i, '');
    return `<label class="filter-checkbox filter-checkbox--expansion">
      <input type="checkbox" data-filter="expansion" data-value="${escapeAttribute(expansion.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''))}" data-tag="${escapeAttribute(expansion)}">
      <span class="filter-checkbox__label">${escapeHtml(display)}</span>
    </label>`;
  }

  function eventSeriesMarkup(group, expansions) {
    return `<div class="filter-series-group" data-series="${escapeAttribute(group.key)}">
      <label class="filter-checkbox filter-checkbox--series">
        <input type="checkbox" data-filter="series" data-value="${escapeAttribute(group.key)}" data-series-aliases="" data-tag="${escapeAttribute(group.label)}">
        <span class="filter-checkbox__label">${escapeHtml(group.label)}</span>
      </label>
      <div class="filter-expansions" style="display: none;">
        ${expansions.map(eventExpansionMarkup).join('')}
      </div>
    </div>`;
  }

  function rebuildEventSeriesFilters(products) {
    if (!collectionPage?.classList.contains('collection-page--event')) return;
    const container = document.querySelector('.filter-group__content--series');
    if (!container) return;

    const tagsByName = new Map();
    products.forEach(product => {
      (product.tags || []).forEach(tag => {
        if (eventFilterTagAllowed(tag)) tagsByName.set(String(tag).trim().toLowerCase(), String(tag).trim());
      });
    });

    const renderedTags = new Set();
    const groups = [];
    eventSeriesGroups.forEach(group => {
      const expansions = [];
      group.expansions.forEach(expected => {
        const actual = tagsByName.get(expected.toLowerCase());
        if (!actual || renderedTags.has(actual.toLowerCase())) return;
        renderedTags.add(actual.toLowerCase());
        expansions.push(actual);
      });
      if (expansions.length > 0) groups.push({ group, expansions });
    });

    const otherExpansions = Array.from(tagsByName.values())
      .filter(tag => !renderedTags.has(tag.toLowerCase()))
      .sort((first, second) => first.localeCompare(second));
    if (otherExpansions.length > 0) {
      groups.push({ group: { key: 'other-sets', label: 'Other Sets' }, expansions: otherExpansions });
    }

    container.innerHTML = groups.map(({ group, expansions }) => eventSeriesMarkup(group, expansions)).join('');
    refreshSeriesFilterControls();
  }

  function selectedGames() {
    return Array.from(document.querySelectorAll('input[data-filter="game"]:checked')).map(input => input.dataset.value);
  }

  function syncGameSeriesVisibility() {
    if (!isAllProductsCollection) return;
    const selected = new Set(selectedGames());
    document.querySelectorAll('[data-filter-game]').forEach(group => {
      group.hidden = !selected.has(group.dataset.filterGame);
      if (!group.hidden) return;
      group.querySelectorAll('input').forEach(input => { input.checked = false; });
      group.querySelectorAll('.filter-expansions').forEach(expansions => { expansions.style.display = 'none'; });
    });
    const hint = document.querySelector('[data-game-hint]');
    if (hint) hint.hidden = selected.size > 0;
  }

  function rebuildGameFilters(products) {
    if (!isAllProductsCollection) return;
    const availableGames = new Set(products.map(gameCatalog.gameFor));
    const games = gameCatalog.games.filter(([key]) => availableGames.has(key));
    document.querySelector('[data-game-options]').innerHTML = games.map(([key, label]) => `
      <label class="filter-checkbox"><input type="checkbox" data-filter="game" data-value="${key}">
        <span class="filter-checkbox__label">${escapeHtml(label)}</span>
      </label>`).join('');
    document.querySelector('.filter-group__content--series').innerHTML =
      '<p class="filter-game-hint" data-game-hint>Select a game to see its series and expansions.</p>' +
      games.map(([key, label]) => {
        const groups = gameCatalog.groupsFor(key, products, gameDefinitions, gameReleaseOrder);
        return `<div class="filter-game-series" data-filter-game="${key}" hidden>
          <h2 class="filter-game-series__title">${escapeHtml(label)}</h2>
          ${groups.length ? groups.map(group => eventSeriesMarkup(group, group.expansions)).join('') : '<p class="filter-game-hint">No series or expansions available.</p>'}
        </div>`;
      }).join('');
    document.querySelectorAll('input[data-filter="game"]').forEach(input => {
      input.addEventListener('change', () => {
        syncGameSeriesVisibility();
        applyFilters();
      });
    });
    refreshSeriesFilterControls();
  }

  function getProductCacheKey(shouldLoadFilterCollections) {
    const version = cacheVersion || storefrontCacheVersion || 'unversioned';
    const scope = shouldLoadFilterCollections
      ? `${collectionCategoryBase || collectionHandle}:${allFilterCollections.slice().sort().join('|')}`
      : collectionHandle;
    return `${productCachePrefix}${productCacheSchemaVersion}:${version}:${scope}`;
  }

  function readProductCache(cacheKey) {
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (!cached || !Array.isArray(cached.products)) return null;
      if (Date.now() - Number(cached.createdAt || 0) > productCacheMaxAgeMs) {
        sessionStorage.removeItem(cacheKey);
        return null;
      }
      return cached.products;
    } catch (e) {
      return null;
    }
  }

  function writeProductCache(cacheKey, products) {
    try {
      const currentVersionPrefix = `${productCachePrefix}${productCacheSchemaVersion}:${cacheVersion || storefrontCacheVersion || 'unversioned'}:`;
      sessionStorage.setItem(cacheKey, JSON.stringify({
        createdAt: Date.now(),
        products
      }));
      Object.keys(sessionStorage).forEach(key => {
        if (key.indexOf(productCachePrefix) === 0 && key.indexOf(currentVersionPrefix) !== 0) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      // Browser storage can fill up; fetching live remains the fallback.
    }
  }

  // Grid Toggle
  const gridToggleBtns = document.querySelectorAll('.grid-toggle__btn');

  // Load saved grid preference
  const savedColumns = localStorage.getItem('gridColumns') || '7';
  productGrid?.setAttribute('data-columns', savedColumns);
  gridToggleBtns.forEach(btn => {
    btn.classList.toggle('active', btn.dataset.columns === savedColumns);
  });

  gridToggleBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const columns = this.dataset.columns;
      productGrid?.setAttribute('data-columns', columns);
      localStorage.setItem('gridColumns', columns);

      gridToggleBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Fetch all products from a single collection
  async function fetchCollectionProducts(handle) {
    const products = [];
    let page = 1;
    const limit = 250; // Max per request
    const sourceType = handle.includes('-graded')
      ? 'graded'
      : (handle.includes('-sealed') ? 'sealed' : (handle.includes('-singles') ? 'singles' : ''));

    try {
      while (true) {
        const response = await fetch(`/collections/${handle}/products.json?limit=${limit}&page=${page}`);
        if (!response.ok) {
          throw new Error(`Product fetch failed for ${handle}: ${response.status}`);
        }
        const data = await response.json();

        if (data.products && data.products.length > 0) {
          products.push(...data.products.map(product => ({
            ...product,
            _sourceCollection: handle,
            _sourceCollections: [handle],
            _sourceType: sourceType,
            _sourceTypes: sourceType ? [sourceType] : []
          })));
          if (data.products.length < limit) break; // Last page
          page++;
        } else {
          break;
        }
      }
    } catch (error) {
      productLoadFailed = true;
      console.error(`Error fetching products from ${handle}:`, error);
    }

    return products;
  }

  // Fetch products from all series collections and deduplicate
  async function fetchLegacyProducts() {
    const loadingText = loadingEl?.querySelector('p');

    // Fetch all collections in parallel
    if (loadingText) {
      loadingText.textContent = `Loading ${allFilterCollections.length} collections...`;
    }

    const results = await Promise.all(
      allFilterCollections.map(handle => fetchCollectionProducts(handle))
    );

    // Deduplicate by product ID
    const productsById = new Map();
    const allFetched = [];

    for (const products of results) {
      for (const product of products) {
        if (!productsById.has(product.id)) {
          productsById.set(product.id, product);
          allFetched.push(product);
        } else {
          const existing = productsById.get(product.id);
          if (existing) {
            const sourceCollections = new Set([
              ...(Array.isArray(existing._sourceCollections) ? existing._sourceCollections : []),
              existing._sourceCollection,
              product._sourceCollection
            ].filter(Boolean));
            existing._sourceCollections = Array.from(sourceCollections);

            const sourceTypes = new Set([
              ...(Array.isArray(existing._sourceTypes) ? existing._sourceTypes : []),
              existing._sourceType,
              product._sourceType
            ].filter(Boolean));
            existing._sourceTypes = Array.from(sourceTypes);

            if (product._sourceType && !existing._sourceType) {
              existing._sourceType = product._sourceType;
            }

            const existingSeries = getSeriesSuffixFromHandle(existing._sourceCollection || '');
            const productSeries = getSeriesSuffixFromHandle(product._sourceCollection || '');
            if (!existingSeries && productSeries) {
              existing._sourceCollection = product._sourceCollection;
            }
          }
        }
      }
    }

    if (loadingText) {
      loadingText.textContent = 'Preparing products...';
    }

    return allFetched;
  }

  async function fetchProductsForPage(shouldLoadFilterCollections) {
    // Direct collections already use one non-overlapping source. Keep their lighter native path.
    if (!shouldLoadFilterCollections) return fetchCollectionProducts(collectionHandle);
    try {
      const catalog = window.TMMCollectionCatalog;
      const options = { root: config.root, market: config.market, version: cacheVersion || storefrontCacheVersion || '' };
      // Type roots cover the series without repeating each series' full product data.
      // The category root is not sufficient on this store: Pokémon excludes graded cards.
      const roots = filterSources.filter(source =>
        ['singles', 'graded', 'sealed'].some(type => source.handle === `${collectionCategoryBase}-${type}`));
      const expected = [...filterSources, { handle: collectionCategoryBase, count: config.categoryCount }];
      let products = await catalog.loadSources(options, roots.length ? roots : [expected[expected.length - 1]]);
      try {
        catalog.assertCoverage(products, expected);
      } catch (_) {
        // A manually assigned card can belong only to a category/series, outside its type root.
        products = await catalog.load({ ...options, collection: 'all', pages: config.allCatalogPages });
        catalog.assertCoverage(products, expected);
      }
      return catalog.forCollection(products, allFilterCollections, collectionCategoryBase);
    } catch (error) {
      // Keep the existing catalog path as recovery for invalid/incomplete compact responses.
      console.warn('Compact catalog unavailable; using collection catalog.', error);
      return shouldLoadFilterCollections ? fetchLegacyProducts() : fetchCollectionProducts(collectionHandle);
    }
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/"/g, '&quot;');
  }

  function isLanguageTag(tag) {
    return String(tag || '').trim().toLowerCase().startsWith('language:');
  }

  function isControlTag(tag) {
    const normalized = String(tag || '').trim().toLowerCase();
    return normalized.startsWith('language:') ||
      normalized.startsWith('condition:') ||
      normalized.startsWith('promo type:') ||
      normalized.startsWith('card treatment:') ||
      normalized.startsWith('grader:') ||
      normalized.startsWith('grade:') ||
      normalized.startsWith('sport:') ||
      normalized.startsWith('team:') ||
      normalized.startsWith('player:') ||
      normalized.startsWith('manufacturer:') ||
      normalized.startsWith('set:') ||
      normalized.startsWith('set code:') ||
      normalized.startsWith('collector number:') ||
      normalized.startsWith('card number:') ||
      normalized.startsWith('title:') ||
      normalized.startsWith('title code:') ||
      normalized.startsWith('rarity:') ||
      normalized.startsWith('card type:') ||
      normalized.startsWith('finish:') ||
      normalized.startsWith('printing:') ||
      normalized.startsWith('year:') ||
      normalized.startsWith('variant:');
  }

  function productLanguage(product) {
    const languageTag = (product.tags || []).find(isLanguageTag);
    if (!languageTag) return 'EN';
    return String(languageTag).split(':').slice(1).join(':').trim().toUpperCase() || 'EN';
  }

  function languageFilterHasJapanese() {
    const group = document.querySelector('[data-language-filter-group]');
    return group?.dataset.hasJapanese === 'true';
  }

  function updateLanguageFilterAvailability(products) {
    const group = document.querySelector('[data-language-filter-group]');
    if (!group) return;

    const hasJapanese = products.some(product => productLanguage(product) === 'JP');
    group.dataset.hasJapanese = hasJapanese ? 'true' : 'false';
    group.style.display = hasJapanese ? '' : 'none';

    if (!hasJapanese) {
      group.querySelectorAll('input[data-filter="language"]').forEach(input => {
        input.checked = false;
      });
    }
  }

  function displayProductTag(product) {
    if (collectionCategoryBase === 'sports') {
      return getControlTagValue(product, 'set') || getControlTagValue(product, 'sport');
    }
    if (['magic', 'lorcana', 'gundam'].includes(collectionCategoryBase)) {
      return getControlTagValue(product, 'set');
    }
    if (collectionCategoryBase === 'union-arena') {
      return getControlTagValue(product, 'set') || getControlTagValue(product, 'title');
    }
    return (product.tags || []).find(tag => !isControlTag(tag)) || '';
  }

  function handleize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildDisplayTagUrl(product, displayTag, productType) {
    if (!displayTag) return '';

    const tagHandle = handleize(displayTag);
    const sourceCollections = getProductSourceCollections(product);
    const directCollection = sourceCollections.find(handle => {
      const normalized = String(handle || '').toLowerCase();
      return normalized.includes(tagHandle) && normalized.includes(`-${productType}-`);
    });
    if (directCollection) return `/collections/${directCollection}`;
    return '';
  }

  function isVariantSold(variant) {
    return recentlySold.isVariantSold(variant);
  }

  function isVariantHidden(variant) {
    return recentlySold.isVariantHidden(variant);
  }

  function availableVisibleVariants(product) {
    return (product.variants || []).filter(variant =>
      recentlySold.isVariantAvailable(variant) &&
      (isLiveEventCollection() ? isVariantAtTradeShow(product, variant) : !isVariantAtTradeShow(product, variant))
    );
  }

  function availableVisibleVariantCount(product) {
    return availableVisibleVariants(product).length;
  }

  function hasRecentlySoldVariant(product) {
    return recentlySold.hasRecentlySoldVariant(product);
  }

  function latestSoldVariant(product) {
    return recentlySold.latestSoldVariant(product, new Date(), true);
  }

  // Products the grid can ever show: not all variants hidden, and available or recently sold.
  function isStorefrontVisible(product) {
    const allVariantsHidden = product.variants && product.variants.length > 0 && product.variants.every(isVariantHidden);
    return !allVariantsHidden && shouldIncludeStorefrontProduct(product);
  }

  // Counts beside list filter options: visible products in this collection, other selected filters ignored.
  function updateListFilterCounts() {
    const containers = document.querySelectorAll('.filter-type-options--list[data-sports-filter-options]');
    if (!containers.length) return;
    const visible = allProducts.filter(isStorefrontVisible);
    containers.forEach(container => {
      const key = container.dataset.sportsFilterOptions;
      const counts = new Map();
      visible.forEach(product => {
        const value = getControlTagValue(product, key).toLowerCase();
        if (value) counts.set(value, (counts.get(value) || 0) + 1);
      });
      let shown = 0;
      container.querySelectorAll('label').forEach(label => {
        const input = label.querySelector('input');
        const total = counts.get((input?.dataset.value || '').toLowerCase()) || 0;
        const count = label.querySelector('.filter-checkbox__count');
        if (count) count.textContent = total;
        // Values only sold-out or hidden copies carry would give an empty result.
        label.hidden = total === 0 && !input?.checked;
        if (!label.hidden) shown += 1;
      });
      const showAll = container.querySelector('.filter-show-all');
      if (showAll) {
        showAll.dataset.total = shown;
        if (container.classList.contains('is-collapsed')) showAll.textContent = `Show all (${shown})`;
      }
    });
  }

  function shouldIncludeStorefrontProduct(product) {
    if (availableVisibleVariantCount(product) > 0) return true;
    return recentlySold.isRecentlySoldEligibleProduct(product) && hasRecentlySoldVariant(product);
  }

  function variantConditionKey(variant) {
    const explicit = String(
      variant?.condition_abbreviation || variant?.condition || variant?.condition_name || ''
    ).trim().toUpperCase();
    if (explicit) {
      if (explicit === 'NEAR MINT') return 'NM';
      if (explicit === 'LIGHTLY PLAYED') return 'LP';
      if (explicit === 'MODERATELY PLAYED') return 'MP';
      if (explicit === 'HEAVILY PLAYED') return 'HP';
      if (explicit === 'DAMAGED') return 'D';
      return explicit;
    }
    const titleMatch = String(variant?.title || '').toUpperCase().match(/\((NM|LP|MP|HP|D)\)/);
    return titleMatch ? titleMatch[1] : 'UNSPECIFIED';
  }

  let productSummaries = new WeakMap();
  function customerPriceSummary(product) {
    // Inventory is verified before rendering and changes require a page refresh.
    if (!productSummaries.has(product)) productSummaries.set(product, computeCustomerPriceSummary(product));
    return productSummaries.get(product);
  }

  function computeCustomerPriceSummary(product) {
    const variants = availableVisibleVariants(product);
    const pricedVariants = variants.filter(variant => Number.isFinite(parseFloat(variant?.price)));
    if (pricedVariants.length === 0) {
      return { variants, min: null, max: null, showRange: false, compareAtPrice: null, isOnSale: false };
    }

    const prices = pricedVariants.map(variant => parseFloat(variant.price));
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    const conditionCount = new Set(pricedVariants.map(variantConditionKey)).size;
    const compareAtPrices = pricedVariants
      .filter(variant => parseFloat(variant?.compare_at_price) > parseFloat(variant.price))
      .map(variant => parseFloat(variant.compare_at_price));

    return {
      variants,
      min,
      max,
      showRange: conditionCount > 1 && min !== max,
      compareAtPrice: compareAtPrices.length ? Math.max(...compareAtPrices) : null,
      isOnSale: compareAtPrices.length > 0
    };
  }

  const pokemonPromoCodes = new Set([
    'MEP', 'SVP', 'SWSHP', 'SMP', 'XYP', 'BWP', 'HSP', 'DPP', 'NP', 'WP',
    'M-P', 'SV-P', 'S-P', 'SM-P', 'XY-P', 'BW-P', 'L-P', 'DPT-P', 'PCG-P', 'P'
  ]);
  const pokemonSealedPromoCodes = new Set([
    'MESP', 'SVSP', 'SWSHSP', 'SMSP', 'XYSP', 'BWSP', 'HSSP', 'DPSP', 'NSP', 'WSP',
    'M-SP', 'SV-SP', 'S-SP', 'SM-SP', 'XY-SP', 'BW-SP', 'L-SP', 'DPT-SP', 'PCG-SP', 'SP'
  ]);
  const pokemonKnownPromoCodes = Array.from(new Set([
    ...pokemonPromoCodes,
    ...pokemonSealedPromoCodes
  ])).sort((a, b) => b.length - a.length);

  function getPokemonCardNumber(product) {
    const match = String(product?.title || '').toUpperCase().match(/#\s*([A-Z0-9-]+)(?:\/[A-Z0-9-]+)?/);
    return match ? match[1] : '';
  }

  function getPokemonSkuExpansionCode(product, variant) {
    const parts = String(variant?.sku || '')
      .trim()
      .toUpperCase()
      .split('.')
      .map(part => part.trim())
      .filter(Boolean);
    const codeAndNumber = parts[0] === 'JP' ? parts[2] : parts[1];
    if (!codeAndNumber) return '';

    const cardNumber = getPokemonCardNumber(product);
    if (cardNumber && codeAndNumber.endsWith(cardNumber)) {
      return codeAndNumber.slice(0, -cardNumber.length);
    }

    return pokemonKnownPromoCodes.find(code =>
      code.length > 1 && codeAndNumber.startsWith(code)
    ) || '';
  }

  function getPokemonPromoTypes(product) {
    const explicitPromoType = getControlTagValue(product, 'promo type').toLowerCase();
    const promoTypes = new Set();
    if (explicitPromoType === 'promo') promoTypes.add('promo');
    if (explicitPromoType === 'sealed promo') promoTypes.add('sealed-promo');

    (product.variants || [])
      .filter(variant => recentlySold.isVariantAvailable(variant))
      .forEach(variant => {
        const expansionCode = getPokemonSkuExpansionCode(product, variant);
        if (pokemonSealedPromoCodes.has(expansionCode)) {
          promoTypes.add('sealed-promo');
        } else if (pokemonPromoCodes.has(expansionCode)) {
          promoTypes.add('promo');
        }
      });

    return promoTypes;
  }

  function getCurrentState(scrollY = window.scrollY) {
    const sports = {};
    document.querySelectorAll('[data-sports-filter-group]').forEach(group => {
      const key = group.dataset.sportsFilterGroup;
      sports[key] = Array.from(group.querySelectorAll('input[data-filter="sports"]:checked'))
        .map(input => input.dataset.value)
        .filter(Boolean);
    });
    return {
      q: searchInput?.value || '',
      min: priceMin?.value || '',
      max: priceMax?.value || '',
      sort: sortSelect?.value || 'title-ascending',
      games: selectedGames(),
      productTypes: Array.from(document.querySelectorAll('input[data-filter="product-type"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      languages: Array.from(document.querySelectorAll('input[data-filter="language"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      promoTypes: Array.from(document.querySelectorAll('input[data-filter="promo-type"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      graders: Array.from(document.querySelectorAll('input[data-filter="grader"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      grades: Array.from(document.querySelectorAll('input[data-filter="grade"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      series: Array.from(document.querySelectorAll('input[data-filter="series"]:checked')).map(cb => cb.dataset.value).filter(Boolean),
      expansions: Array.from(document.querySelectorAll('input[data-filter="expansion"]:checked')).map(cb => cb.dataset.tag).filter(Boolean),
      sports,
      columns: productGrid?.dataset.columns || savedColumns,
      renderedCount: cardRenderer.getRenderedCount(),
      scrollY
    };
  }

  function readUrlState() {
    const params = new URLSearchParams(window.location.search);
    const sportsKeys = ['sport', 'team', 'manufacturer', 'set', 'year', 'variant', 'title', 'rarity', 'card type', 'finish', 'printing'];
    const hasState = ['q', 'min', 'max', 'sort', 'game', 'type', 'lang', 'promo', 'grader', 'grade', 'series', 'expansion', ...sportsKeys].some(key => params.has(key));
    if (!hasState) return null;
    return {
      q: params.get('q') || '',
      min: params.get('min') || '',
      max: params.get('max') || '',
      sort: params.get('sort') || 'title-ascending',
      games: (params.get('game') || '').split(',').filter(Boolean),
      productTypes: (params.get('type') || '').split(',').map(v => v.trim()).filter(Boolean),
      languages: (params.get('lang') || '').split(',').map(v => v.trim()).filter(Boolean),
      promoTypes: (params.get('promo') || '').split(',').map(v => v.trim()).filter(Boolean),
      graders: (params.get('grader') || '').split(',').map(v => v.trim()).filter(Boolean),
      grades: (params.get('grade') || '').split(',').map(v => v.trim()).filter(Boolean),
      series: (params.get('series') || '').split(',').map(v => v.trim()).filter(Boolean),
      expansions: params.getAll('expansion').map(v => v.trim()).filter(Boolean),
      sports: Object.fromEntries(sportsKeys.map(key => [
        key,
        (params.get(key) || '').split(',').map(v => v.trim()).filter(Boolean)
      ])),
      scrollY: Number(params.get('scroll') || 0)
    };
  }

  function readSavedState() {
    try {
      return JSON.parse(sessionStorage.getItem(collectionStateKey) || 'null');
    } catch (e) {
      return null;
    }
  }

  function shouldRestoreSavedState() {
    const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
    return ['back_forward', 'reload'].includes(navigationEntry?.type) || document.referrer.includes('/products/');
  }

  function getSeriesSuffixFromHandle(handle) {
    if (!collectionCategoryBase) return '';
    const singlesPrefix = `${collectionCategoryBase}-singles-`;
    const gradedPrefix = `${collectionCategoryBase}-graded-`;
    const sealedPrefix = `${collectionCategoryBase}-sealed-`;
    if (handle.startsWith(singlesPrefix)) return handle.slice(singlesPrefix.length);
    if (handle.startsWith(gradedPrefix)) return handle.slice(gradedPrefix.length);
    if (handle.startsWith(sealedPrefix)) return handle.slice(sealedPrefix.length);
    return '';
  }

  function getProductSourceCollections(product) {
    return Array.from(new Set([
      product._sourceCollection,
      ...(Array.isArray(product._sourceCollections) ? product._sourceCollections : [])
    ].filter(Boolean)));
  }

  function getProductSeriesSuffixes(product) {
    return getProductSourceCollections(product)
      .map(handle => getSeriesSuffixFromHandle(handle).toLowerCase())
      .filter(Boolean);
  }

  function getDefaultCollectionState() {
    const productTypes = [];
    if (collectionCategoryBase && collectionHandle.startsWith(`${collectionCategoryBase}-singles`)) {
      productTypes.push('singles');
    } else if (collectionCategoryBase && collectionHandle.startsWith(`${collectionCategoryBase}-graded`)) {
      productTypes.push('graded');
    } else if (collectionCategoryBase && collectionHandle.startsWith(`${collectionCategoryBase}-sealed`)) {
      productTypes.push('sealed');
    }

    const seriesSuffix = getSeriesSuffixFromHandle(collectionHandle);
    const currentSeriesCheckbox = seriesSuffix
      ? Array.from(seriesCheckboxes).find(cb => {
          const aliases = (cb.dataset.seriesAliases || '').split(',').map(v => v.trim()).filter(Boolean);
          return cb.dataset.value === seriesSuffix || aliases.includes(seriesSuffix);
        })
      : null;

    if (productTypes.length === 0 && !currentSeriesCheckbox) return null;

    return {
      q: '',
      min: '',
      max: '',
      sort: sortSelect?.value || 'title-ascending',
      productTypes,
      languages: [],
      promoTypes: [],
      graders: [],
      grades: [],
      series: currentSeriesCheckbox ? [currentSeriesCheckbox.dataset.value] : [],
      expansions: [],
      sports: {},
      scrollY: 0
    };
  }

  function mergeWithDefaultState(state, options = {}) {
    const defaults = getDefaultCollectionState();
    if (!state) return defaults;
    if (!defaults) return state;

    const merged = { ...defaults, ...state };
    if (options.fillMissingProductTypes && (!state.productTypes || state.productTypes.length === 0)) {
      merged.productTypes = defaults.productTypes || [];
    }
    if (options.fillMissingSeries && (!state.series || state.series.length === 0)) {
      merged.series = defaults.series || [];
    }
    return merged;
  }

  function applyStateToControls(state) {
    if (!state) return;
    if (searchInput && state.q != null) searchInput.value = state.q;
    if (sortSelect && state.sort) sortSelect.value = state.sort;
    if (priceMin && state.min !== '') priceMin.value = clampPrice(state.min, 0);
    if (priceMax && state.max !== '') priceMax.value = clampPrice(state.max, maxProductPrice);
    if (sliderMin && priceMin) sliderMin.value = priceMin.value;
    if (sliderMax && priceMax) sliderMax.value = priceMax.value;

    const selectedProductTypes = new Set((state.productTypes || state.types || []).map(v => v.toLowerCase()));
    const selectedLanguages = new Set((state.languages || []).map(v => v.toUpperCase()));
    const selectedPromoTypes = new Set((state.promoTypes || []).map(v => v.toLowerCase()));
    const selectedGraders = new Set((state.graders || []).map(v => v.toLowerCase()));
    const selectedGrades = new Set((state.grades || []).map(v => v.toLowerCase()));
    const selectedSeries = new Set((state.series || []).map(v => v.toLowerCase()));
    const selectedExpansions = new Set((state.expansions || []).map(v => v.toLowerCase()));
    const selectedSports = state.sports || {};
    const gameSelection = new Set(state.games || []);
    document.querySelectorAll('input[data-filter="game"]').forEach(input => {
      input.checked = gameSelection.has(input.dataset.value);
    });

    productTypeCheckboxes.forEach(cb => {
      cb.checked = selectedProductTypes.has((cb.dataset.value || '').toLowerCase());
    });

    languageCheckboxes.forEach(cb => {
      cb.checked = languageFilterHasJapanese() && selectedLanguages.has((cb.dataset.value || '').toUpperCase());
    });

    promoTypeCheckboxes.forEach(cb => {
      cb.checked = selectedPromoTypes.has((cb.dataset.value || '').toLowerCase());
    });

    document.querySelectorAll('input[data-filter="grader"]').forEach(cb => {
      cb.checked = selectedGraders.has((cb.dataset.value || '').toLowerCase());
    });
    document.querySelectorAll('input[data-filter="grade"]').forEach(cb => {
      cb.checked = selectedGrades.has((cb.dataset.value || '').toLowerCase());
    });

    seriesCheckboxes.forEach(cb => {
      const aliases = (cb.dataset.seriesAliases || '').split(',').map(v => v.trim().toLowerCase()).filter(Boolean);
      cb.checked = selectedSeries.has((cb.dataset.value || '').toLowerCase()) ||
        aliases.some(alias => selectedSeries.has(alias));
      const expansions = cb.closest('.filter-series-group')?.querySelector('.filter-expansions');
      if (expansions) expansions.style.display = cb.checked ? 'block' : 'none';
    });

    document.querySelectorAll('input[data-filter="expansion"]').forEach(cb => {
      const game = cb.closest('[data-filter-game]')?.dataset.filterGame;
      const isChecked = (!game || gameSelection.has(game)) && selectedExpansions.has((cb.dataset.tag || '').toLowerCase());
      cb.checked = isChecked;
      if (isChecked) {
        const seriesGroup = cb.closest('.filter-series-group');
        const seriesCheckbox = seriesGroup?.querySelector('input[data-filter="series"]');
        const expansions = seriesGroup?.querySelector('.filter-expansions');
        if (seriesCheckbox) seriesCheckbox.checked = true;
        if (expansions) expansions.style.display = 'block';
      }
    });

    document.querySelectorAll('[data-sports-filter-group]').forEach(group => {
      const key = group.dataset.sportsFilterGroup;
      const selected = new Set((selectedSports[key] || []).map(value => value.toLowerCase()));
      group.querySelectorAll('input[data-filter="sports"]').forEach(input => {
        input.checked = selected.has((input.dataset.value || '').toLowerCase());
      });
    });

    syncGameSeriesVisibility();
    pendingScrollY = Number(state.scrollY || 0) || null;
    pendingRenderedCount = Math.max(0, Math.floor(Number(state.renderedCount) ||
      (pendingScrollY ? Number.MAX_SAFE_INTEGER : 0)));
    updateSliderVisuals();
  }

  function persistState(scrollY = window.scrollY) {
    const state = getCurrentState(scrollY);

    const params = new URLSearchParams(window.location.search);
    const sportsKeys = ['sport', 'team', 'manufacturer', 'set', 'year', 'variant', 'title', 'rarity', 'card type', 'finish', 'printing'];
    ['q', 'min', 'max', 'sort', 'game', 'type', 'lang', 'promo', 'grader', 'grade', 'series', 'expansion', 'scroll', ...sportsKeys].forEach(key => params.delete(key));
    if (state.games.length) params.set('game', state.games.join(','));
    if (state.q) params.set('q', state.q);
    if (Number(state.min) > 0) params.set('min', state.min);
    if (Number(state.max) < maxProductPrice) params.set('max', state.max);
    if (state.sort && state.sort !== 'title-ascending') params.set('sort', state.sort);
    if (state.productTypes.length > 0) params.set('type', state.productTypes.join(','));
    if (state.languages.length > 0) params.set('lang', state.languages.join(','));
    if (state.promoTypes.length > 0) params.set('promo', state.promoTypes.join(','));
    if (state.graders.length > 0) params.set('grader', state.graders.join(','));
    if (state.grades.length > 0) params.set('grade', state.grades.join(','));
    if (state.series.length > 0) params.set('series', state.series.join(','));
    state.expansions.forEach(expansion => params.append('expansion', expansion));
    sportsKeys.forEach(key => {
      const values = state.sports?.[key] || [];
      if (values.length > 0) params.set(key, values.join(','));
    });

    const nextUrl = params.toString() ? `${window.location.pathname}?${params}` : window.location.pathname;
    state.url = nextUrl;
    sessionStorage.setItem(collectionStateKey, JSON.stringify(state));
    window.history.replaceState({}, '', nextUrl);
  }

  function restoreScrollIfNeeded() {
    if (!pendingScrollY) return;
    const scrollY = pendingScrollY;
    pendingScrollY = null;
    requestAnimationFrame(() => window.scrollTo(0, scrollY));
  }

  function shopifySizedImage(src, width) {
    if (!src) return '';
    const [path, query] = String(src).split('?');
    const sizedPath = path.replace(/\.([^.\/]+)$/, `_${width}x.$1`);
    return query ? `${sizedPath}?${query}` : sizedPath;
  }

  function getProductClass(product) {
    const sourceTypes = Array.isArray(product._sourceTypes) ? product._sourceTypes : [];
    if (sourceTypes.includes('graded')) return 'graded';
    if (sourceTypes.includes('sealed')) return 'sealed';
    if (sourceTypes.includes('singles')) return 'singles';
    if (['singles', 'graded', 'sealed'].includes(product._sourceType)) return product._sourceType;

    const productType = (product.product_type || '').toLowerCase();
    const tags = (product.tags || []).map(tag => String(tag).toLowerCase());
    if (productType.includes('graded') || tags.some(tag => tag.includes('graded'))) return 'graded';
    if (productType.includes('sealed') || tags.some(tag => tag.includes('sealed'))) return 'sealed';
    return 'singles';
  }

  function isSealedProduct(product) {
    return getProductClass(product) === 'sealed';
  }

  function getControlTagValue(product, prefix) {
    const normalizedPrefix = `${String(prefix || '').toLowerCase()}:`;
    const tag = (product.tags || []).find(value =>
      String(value).trim().toLowerCase().startsWith(normalizedPrefix)
    );
    return tag ? String(tag).slice(String(tag).indexOf(':') + 1).trim() : '';
  }

  function populateGradingFilter(groupSelector, optionsSelector, filterName, values, {order = null, list = false} = {}) {
    const group = document.querySelector(groupSelector);
    const container = document.querySelector(optionsSelector);
    if (!group || !container) return;

    const sortedValues = Array.from(values)
      .filter(Boolean)
      .sort((a, b) => {
        if (order) {
          const rank = value => {
            const index = order.findIndex(item => item.toLowerCase() === value.toLowerCase());
            return index === -1 ? order.length : index;
          };
          if (rank(a) !== rank(b)) return rank(a) - rank(b);
        }
        if (filterName === 'grade') {
          const gradeA = Number.parseFloat(a);
          const gradeB = Number.parseFloat(b);
          const gradeAIsNumeric = Number.isFinite(gradeA);
          const gradeBIsNumeric = Number.isFinite(gradeB);
          if (gradeAIsNumeric && gradeBIsNumeric && gradeA !== gradeB) return gradeB - gradeA;
          if (gradeAIsNumeric !== gradeBIsNumeric) return gradeAIsNumeric ? -1 : 1;
        }
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      });
    group.hidden = sortedValues.length === 0;
    const collapsible = list && sortedValues.length > LIST_COLLAPSE_AFTER + 2;
    container.classList.toggle('filter-type-options--list', list);
    container.classList.toggle('is-collapsed', collapsible);
    container.innerHTML = sortedValues.map((value, index) => `
      <label class="filter-checkbox filter-checkbox--type${collapsible && index >= LIST_COLLAPSE_AFTER ? ' filter-checkbox--extra' : ''}">
        <input type="checkbox" data-filter="${filterName}" data-value="${escapeAttribute(value)}">
        <span class="filter-checkbox__label">${escapeHtml(value)}</span>
        ${list ? '<span class="filter-checkbox__count"></span>' : ''}
      </label>
    `).join('') + (collapsible
      ? `<button type="button" class="filter-show-all" aria-expanded="false">Show all (${sortedValues.length})</button>`
      : '');
    container.querySelector('.filter-show-all')?.addEventListener('click', event => {
      const expanded = container.classList.toggle('is-collapsed') === false;
      event.currentTarget.setAttribute('aria-expanded', String(expanded));
      event.currentTarget.textContent = expanded ? 'Show fewer' : `Show all (${event.currentTarget.dataset.total || sortedValues.length})`;
    });
    container.querySelectorAll(`input[data-filter="${filterName}"]`).forEach(checkbox => {
      checkbox.addEventListener('change', applyFilters);
    });
  }

  function updateGradingFilterAvailability(products) {
    const gradedProducts = products.filter(product => getProductClass(product) === 'graded');
    populateGradingFilter(
      '[data-grader-filter-group]',
      '[data-grader-filter-options]',
      'grader',
      new Set(gradedProducts.map(product => getControlTagValue(product, 'grader')))
    );
    populateGradingFilter(
      '[data-grade-filter-group]',
      '[data-grade-filter-options]',
      'grade',
      new Set(gradedProducts.map(product => getControlTagValue(product, 'grade')))
    );
  }

  function updateSportsFilterAvailability(products) {
    document.querySelectorAll('[data-sports-filter-group]').forEach(group => {
      const key = group.dataset.sportsFilterGroup;
      populateGradingFilter(
        `[data-sports-filter-group="${key}"]`,
        `[data-sports-filter-options="${key}"]`,
        'sports',
        new Set(products.map(product => getControlTagValue(product, key))),
        {order: FILTER_ORDERS[collectionCategoryBase]?.[key], list: true}
      );
    });
  }

  // Create product card HTML
  function createProductCard(product, imageOptions = {}) {
    const priceSummary = customerPriceSummary(product);
    const price = priceSummary.min;
    const comparePrice = priceSummary.compareAtPrice;
    const tags = product.tags.join(',').toLowerCase().replace(/\s+/g, '-');
    const firstTag = displayProductTag(product);
    const available = priceSummary.variants.length > 0;
    const productClass = getProductClass(product);
    const isInStoreOnly = productClass === 'sealed';
    const gradingCompany = getControlTagValue(product, 'grader');
    const grade = getControlTagValue(product, 'grade');
    let displayTitle = product.title || '';
    if (productClass === 'graded' && gradingCompany && grade) {
      const gradingTitleSuffix = ` - ${gradingCompany} ${grade}`;
      if (displayTitle.endsWith(gradingTitleSuffix)) {
        displayTitle = displayTitle.slice(0, -gradingTitleSuffix.length).trim();
      }
    }
    const firstTagUrl = buildDisplayTagUrl(product, firstTag, productClass);
    const visibleVariants = priceSummary.variants;
    const availableVariantCount = visibleVariants.length;
    const latestSold = latestSoldVariant(product);
    const soldOnly = availableVariantCount === 0 && Boolean(latestSold);
    const hasInventoryCounts = visibleVariants.some(v => Number.isFinite(Number(v.inventory_quantity)));
    let sealedStockCount = visibleVariants.reduce((sum, v) => {
      const qty = Number(v.inventory_quantity);
      return sum + (Number.isFinite(qty) && qty > 0 ? qty : 0);
    }, 0);
    if (isInStoreOnly && !hasInventoryCounts) {
      sealedStockCount = availableVariantCount;
    }
    if (!shouldIncludeStorefrontProduct(product)) {
      return '';
    }

    // Format price
    const formatMoney = (cents) => {
      const dollars = parseFloat(cents);
      return '$' + dollars.toFixed(2);
    };

    // Badge HTML — prefer variant status metafields, with title suffix fallback.
    let badgeHtml = '';
    const allHidden = product.variants && product.variants.length > 0 && product.variants.every(isVariantHidden);
    if (allHidden) {
      // Don't show card at all — handled by filter below
      badgeHtml = '';
    } else if (soldOnly) {
      badgeHtml = '<span class="product-card__badge product-card__badge--sold">Sold</span>';
    } else if (priceSummary.isOnSale) {
      badgeHtml = '<span class="product-card__badge product-card__badge--sale">Sale</span>';
    }
    const gradeBadgeHtml = productClass === 'graded' && gradingCompany && grade
      ? `<span class="product-card__badge product-card__badge--graded">${escapeHtml(gradingCompany)} ${escapeHtml(grade)}</span>`
      : '';
    // Image HTML
    let imageHtml = '';
    if (product.images && product.images.length > 0) {
      const imgSrc = shopifySizedImage(product.images[0].src, 600);
      const imgSrcset = [
        `${shopifySizedImage(product.images[0].src, 160)} 160w`,
        `${shopifySizedImage(product.images[0].src, 240)} 240w`,
        `${shopifySizedImage(product.images[0].src, 320)} 320w`,
        `${shopifySizedImage(product.images[0].src, 480)} 480w`,
        `${shopifySizedImage(product.images[0].src, 600)} 600w`,
        `${shopifySizedImage(product.images[0].src, 800)} 800w`,
        `${shopifySizedImage(product.images[0].src, 1000)} 1000w`,
        `${shopifySizedImage(product.images[0].src, 1200)} 1200w`,
        `${shopifySizedImage(product.images[0].src, 1600)} 1600w`,
        `${shopifySizedImage(product.images[0].src, 2000)} 2000w`
      ].join(', ');
      const imageAlt = product.images[0].alt || `${displayTitle}${firstTag ? ` — ${firstTag}` : ''} product image`;
      imageHtml = `<img src="${escapeAttribute(imgSrc)}" srcset="${escapeAttribute(imgSrcset)}" sizes="${escapeAttribute(imageOptions.sizes || '420px')}" alt="${escapeAttribute(imageAlt)}" class="product-card__image" loading="${imageOptions.eager ? 'eager' : 'lazy'}" decoding="async">`;
    } else {
      imageHtml = `
        <div class="product-card__placeholder">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
            <circle cx="9" cy="9" r="2"></circle>
            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
          </svg>
        </div>
      `;
    }

    // Price HTML
    let priceHtml = '';
    if (priceSummary.isOnSale) {
      priceHtml = `<span class="product-card__compare-price">${formatMoney(comparePrice)}</span>`;
    }

    let currentPriceHtml = '';
    if (soldOnly) {
      currentPriceHtml = `Sold ${escapeHtml(latestSold.display)}`;
    } else if (priceSummary.showRange) {
      currentPriceHtml = `${formatMoney(priceSummary.min)} - ${formatMoney(priceSummary.max)}`;
    } else {
      currentPriceHtml = formatMoney(price);
    }

    const saleClass = soldOnly
      ? ' product-card__current-price--sold'
      : (priceSummary.isOnSale ? ' product-card__current-price--sale' : '');
    const statusHtml = isInStoreOnly && available
      ? '<span class="product-card__price-status">In Store Only</span>'
      : '';
    const stockHtml = isInStoreOnly
      ? `<p class="product-card__stock">${sealedStockCount > 0 ? `${sealedStockCount} in stock` : 'Out of stock'}</p>`
      : `<p class="product-card__stock">${availableVariantCount > 0 ? `${availableVariantCount} in stock` : '0 available'}</p>`;
    const quickAddVariantId = visibleVariants[0]?.id;
    const quickAddHtml = !isInStoreOnly && quickAddVariantId
      ? `<button type="button" class="product-card__quick-add" data-quick-add data-variant-id="${escapeAttribute(quickAddVariantId)}" aria-label="Add ${escapeAttribute(displayTitle)} to cart" title="Add to cart"><svg viewBox="0 0 40 40" aria-hidden="true" focusable="false"><circle cx="20" cy="20" r="17"></circle><path d="M20 11v18M11 20h18"></path></svg></button>`
      : '';

    return `
      <article class="product-card${quickAddHtml ? ' product-card--quick-add' : ''}" data-product-id="${product.id}" data-recently-sold="${soldOnly ? 'true' : 'false'}" data-price="${price ?? 0}" data-tags="${escapeAttribute(tags)}">
        <a href="/products/${encodeURIComponent(product.handle)}" class="product-card__link">
          <div class="product-card__image-wrapper">
            ${imageHtml}
            ${badgeHtml}
            ${gradeBadgeHtml}
          </div>
          <div class="product-card__info">
            <h2 class="product-card__title">${escapeHtml(displayTitle)}</h2>
            ${firstTag ? `<p class="product-card__meta">${
              firstTagUrl
                ? `<span class="product-card__meta-link" role="link" tabindex="0" data-set-link="${escapeAttribute(firstTagUrl)}">${escapeHtml(firstTag)}</span>`
                : escapeHtml(firstTag)
            }</p>` : '<p class="product-card__meta"></p>'}
            ${stockHtml}
            <div class="product-card__price">
              ${priceHtml}
              <span class="product-card__current-price${saleClass}">${currentPriceHtml}</span>
              ${statusHtml}
            </div>
          </div>
        </a>
        ${quickAddHtml}
      </article>
    `;
  }

  const cardRenderer = window.TMMCollectionGrid.create(productGrid, createProductCard,
    () => persistState(window.scrollY));

  function renderProducts(products) {
    const returning = pendingScrollY !== null;
    const changed = cardRenderer.render(products, pendingRenderedCount);
    pendingRenderedCount = 0;
    if (liquidPagination) liquidPagination.style.display = 'none';
    finishCollectionHydration();
    if (changed && !returning && productGrid.getBoundingClientRect().top < -window.innerHeight / 2) {
      productGrid.scrollIntoView({ block: 'start' });
    }
  }

  window.addEventListener('pagehide', () => {
    if (!productsReady) return;
    const state = { ...getCurrentState(), url: window.location.pathname + window.location.search };
    sessionStorage.setItem(collectionStateKey, JSON.stringify(state));
  });

  // Price Range Elements
  const priceMin = document.getElementById('price-min');
  const priceMax = document.getElementById('price-max');
  const sliderMin = document.getElementById('price-slider-min');
  const sliderMax = document.getElementById('price-slider-max');

  let maxProductPrice = 100;

  function getAvailableVariantPrices(product) {
    return availableVisibleVariants(product)
      .map(variant => parseFloat(variant?.price))
      .filter(price => Number.isFinite(price) && price >= 0);
  }

  function calculateMaxProductPrice(products) {
    const prices = products.flatMap(getAvailableVariantPrices);
    if (prices.length === 0) return 100;
    return Math.max(1, Math.ceil(Math.max(...prices)));
  }

  function setPriceRangeBounds(nextMax) {
    maxProductPrice = Math.max(1, Number(nextMax) || 100);

    if (priceMin) {
      priceMin.min = 0;
      priceMin.max = maxProductPrice;
      priceMin.value = 0;
    }
    if (priceMax) {
      priceMax.min = 0;
      priceMax.max = maxProductPrice;
      priceMax.value = maxProductPrice;
    }
    if (sliderMin) {
      sliderMin.min = 0;
      sliderMin.max = maxProductPrice;
      sliderMin.value = 0;
    }
    if (sliderMax) {
      sliderMax.min = 0;
      sliderMax.max = maxProductPrice;
      sliderMax.value = maxProductPrice;
    }
  }

  function clampPrice(value, fallback) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return fallback;
    return Math.min(Math.max(numeric, 0), maxProductPrice);
  }

  // Debounce function
  let filterDebounceTimer;
  function debouncedApplyFilters() {
    clearTimeout(filterDebounceTimer);
    filterDebounceTimer = setTimeout(applyFilters, 150);
  }

  const thumbMin = document.getElementById('thumb-min');
  const thumbMax = document.getElementById('thumb-max');

  function pct(value) {
    const lo = parseFloat(sliderMin.min) || 0;
    const hi = parseFloat(sliderMin.max) || maxProductPrice;
    return ((value - lo) / (hi - lo)) * 100;
  }

  function updateSliderVisuals() {
    if (!sliderMin || !sliderMax) return;
    const minPct = pct(parseFloat(sliderMin.value));
    const maxPct = pct(parseFloat(sliderMax.value));
    if (thumbMin) thumbMin.style.left = minPct + '%';
    if (thumbMax) thumbMax.style.left = maxPct + '%';
    const slider = sliderMin.closest('.price-range__slider');
    slider.style.setProperty('--fill-start', minPct + '%');
    slider.style.setProperty('--fill-end', maxPct + '%');
  }

  function setupThumbDrag(thumbEl, isMin) {
    if (!thumbEl) return;
    function onDrag(clientX) {
      const slider = sliderMin.closest('.price-range__slider');
      const rect = slider.getBoundingClientRect();
      let fraction = (clientX - rect.left) / rect.width;
      fraction = Math.max(0, Math.min(1, fraction));
      const lo = parseFloat(sliderMin.min) || 0;
      const hi = parseFloat(sliderMin.max) || maxProductPrice;
      let value = Math.round(lo + fraction * (hi - lo));
      if (isMin) {
        value = Math.min(value, parseFloat(sliderMax.value));
        sliderMin.value = value;
        if (priceMin) priceMin.value = value;
      } else {
        value = Math.max(value, parseFloat(sliderMin.value));
        sliderMax.value = value;
        if (priceMax) priceMax.value = value;
      }
      updateSliderVisuals();
      debouncedApplyFilters();
    }
    thumbEl.addEventListener('mousedown', function(e) {
      e.preventDefault();
      function onMove(e) { onDrag(e.clientX); }
      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      }
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
    thumbEl.addEventListener('touchstart', function(e) {
      e.preventDefault();
      function onMove(e) { onDrag(e.touches[0].clientX); }
      function onEnd() {
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      }
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    }, { passive: false });
  }

  setupThumbDrag(thumbMin, true);
  setupThumbDrag(thumbMax, false);

  function syncPriceSliders() {
    if (priceMin) priceMin.value = clampPrice(priceMin.value, 0);
    if (priceMax) priceMax.value = clampPrice(priceMax.value, maxProductPrice);
    if (priceMin && sliderMin) sliderMin.value = priceMin.value;
    if (priceMax && sliderMax) sliderMax.value = priceMax.value;
    if (sliderMin && sliderMax) {
      if (parseFloat(sliderMin.value) > parseFloat(sliderMax.value)) sliderMax.value = sliderMin.value;
      if (parseFloat(sliderMax.value) < parseFloat(sliderMin.value)) sliderMin.value = sliderMax.value;
    }
    updateSliderVisuals();
    debouncedApplyFilters();
  }

  priceMin?.addEventListener('change', syncPriceSliders);
  priceMax?.addEventListener('change', syncPriceSliders);

  // Filter Group Toggle
  function setFilterSidebarOpen(isOpen, focusControl = false) {
    if (!filterSidebar) return;

    if (window.matchMedia('(min-width: 769px)').matches && collectionPage?.classList.contains('collection-page--kiosk')) {
      const collectionLayout = collectionPage.querySelector('.collection-layout');
      collectionLayout?.classList.toggle('is-sidebar-collapsed', !isOpen);
      filterToggleBtn?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (focusControl && !isOpen) filterToggleBtn?.focus({ preventScroll: true });
      return;
    }

    filterSidebar.classList.toggle('is-open', isOpen);
    filterToggleBtn?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (!focusControl) return;

    requestAnimationFrame(function() {
      if (isOpen) {
        filterSidebar.scrollIntoView({ behavior: 'auto', block: 'start' });
        filterCloseBtn?.focus({ preventScroll: true });
      } else {
        filterToggleBtn?.focus({ preventScroll: true });
      }
    });
  }

  if (window.matchMedia('(min-width: 769px)').matches && collectionPage?.classList.contains('collection-page--kiosk')) {
    filterToggleBtn?.setAttribute('aria-expanded', 'true');
  }

  filterToggleBtn?.addEventListener('click', function() {
    const desktopKiosk = window.matchMedia('(min-width: 769px)').matches && collectionPage?.classList.contains('collection-page--kiosk');
    const isOpen = desktopKiosk
      ? !collectionPage.querySelector('.collection-layout')?.classList.contains('is-sidebar-collapsed')
      : filterSidebar?.classList.contains('is-open');
    setFilterSidebarOpen(!isOpen, true);
  });

  filterCloseBtn?.addEventListener('click', function() {
    setFilterSidebarOpen(false, true);
  });

  const filterToggles = document.querySelectorAll('.filter-group__toggle');
  filterToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      const content = this.nextElementSibling;
      if (content) {
        content.style.display = expanded ? 'none' : 'block';
      }
    });
  });

  // Series checkbox toggle - show/hide expansions
  const productTypeCheckboxes = document.querySelectorAll('input[data-filter="product-type"]');
  productTypeCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      applyFilters();
    });
  });

  const languageCheckboxes = document.querySelectorAll('input[data-filter="language"]');
  languageCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      applyFilters();
    });
  });

  const promoTypeCheckboxes = document.querySelectorAll('input[data-filter="promo-type"]');
  promoTypeCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      applyFilters();
    });
  });

  let seriesCheckboxes = document.querySelectorAll('input[data-filter="series"]');

  function refreshSeriesFilterControls() {
    seriesCheckboxes = document.querySelectorAll('input[data-filter="series"]');
    seriesCheckboxes.forEach(checkbox => {
      if (checkbox.dataset.filterBound === 'true') return;
      checkbox.dataset.filterBound = 'true';
      checkbox.addEventListener('change', function() {
      const seriesGroup = this.closest('.filter-series-group');
      const expansions = seriesGroup?.querySelector('.filter-expansions');
      if (expansions) {
        expansions.style.display = this.checked ? 'block' : 'none';
        // When unchecking series, also uncheck all its expansions
        if (!this.checked) {
          const expansionCheckboxes = expansions.querySelectorAll('input[data-filter="expansion"]');
          expansionCheckboxes.forEach(exp => exp.checked = false);
        }
      }
      applyFilters();
    });
    });

    document.querySelectorAll('input[data-filter="expansion"]').forEach(checkbox => {
      if (checkbox.dataset.filterBound === 'true') return;
      checkbox.dataset.filterBound = 'true';
      checkbox.addEventListener('change', function() {
        applyFilters();
      });
    });
  }

  refreshSeriesFilterControls();

  // Sort dropdown
  const sortSelect = document.getElementById('sort-by');

  // Load saved sort preference
  const savedSort = localStorage.getItem('collectionSort') || 'title-ascending';
  if (sortSelect) {
    sortSelect.value = savedSort;
  }

  sortSelect?.addEventListener('change', function() {
    localStorage.setItem('collectionSort', this.value);
    applyFilters();
  });

  // Search input
  const searchInput = document.getElementById('collection-search');
  let searchDebounce;
  searchInput?.addEventListener('input', function() {
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(() => applyFilters(), 200);
  });

  // Clear all filters
  const clearAllBtn = document.getElementById('clear-all-filters');
  const clearFiltersBtn = document.getElementById('clear-filters-btn');

  function clearAllFilters() {
    // Reset price
    if (priceMin) priceMin.value = 0;
    if (priceMax) priceMax.value = maxProductPrice;
    if (sliderMin) sliderMin.value = 0;
    if (sliderMax) sliderMax.value = maxProductPrice;

    // Uncheck all checkboxes
    document.querySelectorAll('input[data-filter="game"]').forEach(cb => cb.checked = false);
    syncGameSeriesVisibility();
    productTypeCheckboxes.forEach(cb => cb.checked = false);
    languageCheckboxes.forEach(cb => cb.checked = false);
    promoTypeCheckboxes.forEach(cb => cb.checked = false);
    document.querySelectorAll('input[data-filter="grader"]').forEach(cb => cb.checked = false);
    document.querySelectorAll('input[data-filter="grade"]').forEach(cb => cb.checked = false);
    document.querySelectorAll('input[data-filter="sports"]').forEach(cb => cb.checked = false);
    seriesCheckboxes.forEach(cb => {
      cb.checked = false;
      const seriesGroup = cb.closest('.filter-series-group');
      const expansions = seriesGroup?.querySelector('.filter-expansions');
      if (expansions) expansions.style.display = 'none';
    });
    document.querySelectorAll('input[data-filter="expansion"]').forEach(cb => cb.checked = false);

    // Clear search
    if (searchInput) searchInput.value = '';

    applyFilters();
  }

  clearAllBtn?.addEventListener('click', clearAllFilters);
  clearFiltersBtn?.addEventListener('click', clearAllFilters);
  retryProductsBtn?.addEventListener('click', () => window.location.reload());

  // Sort products function
  function sortProducts(products, sortBy) {
    const sorted = [...products];

    switch (sortBy) {
      case 'title-ascending':
        sorted.sort((a, b) => a.title.localeCompare(b.title));
        break;
      case 'title-descending':
        sorted.sort((a, b) => b.title.localeCompare(a.title));
        break;
      case 'price-ascending':
        sorted.sort((a, b) => (customerPriceSummary(a).min ?? Number.POSITIVE_INFINITY) - (customerPriceSummary(b).min ?? Number.POSITIVE_INFINITY));
        break;
      case 'price-descending':
        sorted.sort((a, b) => (customerPriceSummary(b).min ?? Number.NEGATIVE_INFINITY) - (customerPriceSummary(a).min ?? Number.NEGATIVE_INFINITY));
        break;
      case 'created-descending':
        sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        break;
      case 'created-ascending':
        sorted.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
        break;
      case 'best-selling':
        // Keep original order (Shopify's default for best-selling)
        break;
      case 'manual':
      default:
        // Keep original order
        break;
    }

    return sorted;
  }

  // Main filter function - filters allProducts array
  function applyFilters() {
    updateListFilterCounts();
    // Don't reveal a partial or unsorted grid if controls are used during loading.
    if (!productsReady) return;
    const gameFilters = selectedGames();
    const searchQuery = (searchInput?.value || '').trim().toLowerCase();
    const minPrice = parseFloat(priceMin?.value) || 0;
    const maxPrice = parseFloat(priceMax?.value) || maxProductPrice;
    const productTypeFilters = Array.from(document.querySelectorAll('input[data-filter="product-type"]:checked'))
      .map(cb => cb.dataset.value)
      .filter(Boolean);
    const languageFilters = Array.from(document.querySelectorAll('input[data-filter="language"]:checked'))
      .map(cb => String(cb.dataset.value || '').toUpperCase())
      .filter(Boolean);
    const promoTypeFilters = Array.from(document.querySelectorAll('input[data-filter="promo-type"]:checked'))
      .map(cb => String(cb.dataset.value || '').toLowerCase())
      .filter(Boolean);
    const graderFilters = Array.from(document.querySelectorAll('input[data-filter="grader"]:checked'))
      .map(cb => String(cb.dataset.value || '').toLowerCase())
      .filter(Boolean);
    const gradeFilters = Array.from(document.querySelectorAll('input[data-filter="grade"]:checked'))
      .map(cb => String(cb.dataset.value || '').toLowerCase())
      .filter(Boolean);
    const sportsFilters = {};
    document.querySelectorAll('[data-sports-filter-group]').forEach(group => {
      const key = group.dataset.sportsFilterGroup;
      sportsFilters[key] = Array.from(group.querySelectorAll('input[data-filter="sports"]:checked'))
        .map(input => String(input.dataset.value || '').toLowerCase())
        .filter(Boolean);
    });

    // Build filter data for each checked series
    // For each checked series, get ALL its expansion tags (for series-level filtering)
    // and which specific expansions are checked (for expansion-level filtering)
    const seriesFilters = [];
    document.querySelectorAll('input[data-filter="series"]:checked').forEach(seriesCb => {
      const seriesGroup = seriesCb.closest('.filter-series-group');

      // Get ALL expansion tags under this series (for when no specific expansions are checked)
      const allExpansionTags = [];
      seriesGroup?.querySelectorAll('input[data-filter="expansion"]').forEach(cb => {
        if (cb.dataset.tag) {
          allExpansionTags.push(cb.dataset.tag.toLowerCase());
        }
      });

      // Get only CHECKED expansion tags
      const checkedExpansionTags = [];
      seriesGroup?.querySelectorAll('input[data-filter="expansion"]:checked').forEach(cb => {
        if (cb.dataset.tag) {
          checkedExpansionTags.push(cb.dataset.tag.toLowerCase());
        }
      });

      seriesFilters.push({
        game: seriesCb.closest('[data-filter-game]')?.dataset.filterGame,
        value: seriesCb.dataset.value,
        aliases: (seriesCb.dataset.seriesAliases || '').split(',').map(v => v.trim().toLowerCase()).filter(Boolean),
        allTags: allExpansionTags,
        checkedTags: checkedExpansionTags
      });
    });

    // Filter products
    let filtered = allProducts.filter(product => {
      if (isAllProductsCollection && !gameCatalog.matches(product, gameFilters, seriesFilters)) return false;
      const price = customerPriceSummary(product).min;
      const productTags = product.tags.map(t => t.toLowerCase());
      const productClass = getProductClass(product);
      const productSeriesValues = getProductSeriesSuffixes(product);

      if (!isStorefrontVisible(product)) return false;

      if (productTypeFilters.length > 0) {
        const typeMatch = productTypeFilters.some(type => {
          return type === productClass;
        });
        if (!typeMatch) return false;
      }

      if (languageFilters.length > 0 && !languageFilters.includes(productLanguage(product))) {
        return false;
      }

      if (promoTypeFilters.length > 0) {
        const productPromoTypes = getPokemonPromoTypes(product);
        if (!promoTypeFilters.some(promoType => productPromoTypes.has(promoType))) {
          return false;
        }
      }

      if (graderFilters.length > 0 && !graderFilters.includes(getControlTagValue(product, 'grader').toLowerCase())) {
        return false;
      }

      if (gradeFilters.length > 0 && !gradeFilters.includes(getControlTagValue(product, 'grade').toLowerCase())) {
        return false;
      }

      for (const [key, values] of Object.entries(sportsFilters)) {
        if (values.length > 0 && !values.includes(getControlTagValue(product, key).toLowerCase())) {
          return false;
        }
      }

      // Search filter
      if (searchQuery) {
        const titleMatch = product.title.toLowerCase().includes(searchQuery);
        const tagMatch = productTags.some(t => t.includes(searchQuery));
        const skuMatch = product.variants && product.variants.some(v => v.sku && v.sku.toLowerCase().includes(searchQuery));
        if (!titleMatch && !tagMatch && !skuMatch) return false;
      }

      // Price filter
      const priceMatch = price === null || (price >= minPrice && price <= maxPrice);

      // Series/Expansion filter logic:
      // - If no series checked: show all (no series filter)
      // - If series checked but no expansions checked: show products with ANY expansion from that series
      // - If series checked AND expansions checked: show only products matching those specific expansions
      let tagMatch = true;
      if (!isAllProductsCollection && seriesFilters.length > 0) {
        // Product must match at least one of the checked series
        tagMatch = seriesFilters.some(series => {
          if (series.checkedTags.length > 0) {
            // Specific expansions selected: product must have one of those tags
            return series.checkedTags.some(tag => productTags.includes(tag));
          } else {
            // No specific expansions: product must have any tag from this series
            return productSeriesValues.includes(String(series.value || '').toLowerCase()) ||
              series.aliases.some(alias => productSeriesValues.includes(alias)) ||
              series.allTags.some(tag => productTags.includes(tag));
          }
        });
      }

      return priceMatch && tagMatch;
    });

    // Sort products
    const sortValue = sortSelect?.value || 'title-ascending';
    filtered = sortProducts(filtered, sortValue);

    // Render filtered products
    renderProducts(filtered);

    // Update count
    if (productCount) {
      if (filtered.length === allProducts.length) {
        productCount.textContent = `${totalProducts} products`;
      } else {
        productCount.innerHTML = `<span class="filter-count">${filtered.length}</span> of ${totalProducts} products`;
      }
    }

    // Show/hide no results
    if (errorEl) errorEl.style.display = 'none';
    if (filtered.length === 0) {
      productGrid.style.display = 'none';
      noResults.style.display = 'block';
    } else {
      productGrid.style.display = 'grid';
      noResults.style.display = 'none';
    }

    persistState(pendingScrollY || window.scrollY);
    restoreScrollIfNeeded();
  }

  async function initializeProducts() {
    productsReady = false;
    productSummaries = new WeakMap();
    const shouldLoadFilterCollections = allFilterCollections.length > 0 && isFilterableCategoryCollection;
    const hasLiquidProducts = productGrid && productGrid.children.length > 0;
    if (loadingEl) {
      loadingEl.style.display = 'flex';
    }

    const fetchProducts = () => fetchProductsForPage(shouldLoadFilterCollections);
    const initialCacheKey = getProductCacheKey(shouldLoadFilterCollections);
    // Overlap a cold catalog download with inventory verification, but never reuse
    // that download if the server reports a different catalog version.
    const pendingProducts = readProductCache(initialCacheKey) ? null : fetchProducts();
    await tradeShowPromise;
    const initialProducts = pendingProducts ? await pendingProducts : null;

    const productCacheKey = getProductCacheKey(shouldLoadFilterCollections);
    const cachedProducts = readProductCache(productCacheKey);
    if (cachedProducts) {
      allProducts = cachedProducts;
      productLoadFailed = false;
    } else {
      if (pendingProducts && productCacheKey === initialCacheKey) {
        allProducts = initialProducts;
      } else {
        productLoadFailed = false;
        allProducts = await fetchProducts();
      }

      if (!productLoadFailed && allProducts.length > 0) {
        writeProductCache(productCacheKey, allProducts);
      }
    }

    if (cacheVersion) {
      sessionStorage.setItem('pokemon_cache_version', cacheVersion);
    }

    // Keep products with at least one variant valid for this storefront context.
    if (shouldFilterTradeShow()) {
      allProducts = allProducts.filter(product => availableVisibleVariantCount(product) > 0);
    } else if (isLiveEventCollection()) {
      allProducts = allProducts.filter(product => availableVisibleVariantCount(product) > 0);
    }

    totalProducts = allProducts.length;

    if (productLoadFailed && totalProducts === 0) {
      if (loadingEl) loadingEl.style.display = 'none';
      if (productGrid) productGrid.style.display = shouldLoadFilterCollections ? 'none' : (hasLiquidProducts ? 'grid' : 'none');
      if (noResults) noResults.style.display = 'none';
      if (errorEl) errorEl.style.display = 'block';
      if (productCount) {
        productCount.textContent = hasLiquidProducts && !shouldLoadFilterCollections
          ? `${currentCollectionCount} products`
          : 'Unable to load products';
      }
      finishCollectionHydration();
      return;
    }

    // Set the default range from the current category's available products.
    setPriceRangeBounds(calculateMaxProductPrice(allProducts));
    updateSliderVisuals();
    updateLanguageFilterAvailability(allProducts);
    updateGradingFilterAvailability(allProducts);
    updateSportsFilterAvailability(allProducts);
    rebuildEventSeriesFilters(allProducts);
    rebuildGameFilters(allProducts);

    // Hide loading, show grid
    if (loadingEl) loadingEl.style.display = 'none';
    if (errorEl) errorEl.style.display = 'none';

    // Update header count
    if (productCount) {
      productCount.textContent = `${totalProducts} products`;
    }

    const urlState = readUrlState();
    const savedState = shouldRestoreSavedState() ? readSavedState() : null;
    let restoredState = urlState
      ? mergeWithDefaultState(urlState, { fillMissingProductTypes: true, fillMissingSeries: true })
      : (savedState ? mergeWithDefaultState(savedState) : getDefaultCollectionState());
    // URL filters take precedence, but returning to that same URL must retain its rendered depth.
    if (savedState?.url === window.location.pathname + window.location.search) {
      restoredState = { ...restoredState, renderedCount: savedState.renderedCount, scrollY: savedState.scrollY };
    }
    if (restoredState) {
      applyStateToControls(restoredState);
    }

    productsReady = true;
    applyFilters();
  }

  await initializeProducts();
  startInventoryUpdateWatcher();
});
